import React from "react";

export default function Footer() {
	return (
		<>
			<footer>Andrei Barut &copy; 2022</footer>
		</>
	);
}
